import { Step } from 'react-joyride';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TourGuide } from '../../../../../components';

type TOrdersTour = {
  runTour: boolean
  handleFinishTour: () => void
};

interface ITourStep extends Step {
  skipStep?: boolean
}

const OrdersTour: FC<TOrdersTour> = ({ runTour, handleFinishTour }) => {
  const { t } = useTranslation('tour');

  const tourSteps: Array<ITourStep> = [
    {
      target: '#total-orders',
      disableBeacon: true,
      content: t('thisWidgetDisplaysTheTotalNumberOfOrders'),
    },
    {
      target: '#total-products',
      disableBeacon: true,
      content: t('thisWidgetShowsTheTotalNumberOfProducts'),
    },
    {
      target: '#total-net-sales',
      disableBeacon: true,
      content: t('thisWidgetDisplaysTheTotalNetSales'),
    },
    {
      target: '#total-commissions',
      disableBeacon: true,
      content: t('thisWidgetDisplaysTheTotalCommissions'),
    },
    {
      target: '#locations-filter',
      disableBeacon: true,
      content: t('filterOrdersByLocationOrders'),
    },
    {
      target: '#select-period',
      disableBeacon: true,
      content: t('useThisToLoadMoreOrders'),
    },
    {
      target: '#guide-arrows',
      disableBeacon: true,
      content: t('useTheseArrowsToNavigateOrders'),
    },
    {
      target: '#table-commissions',
      disableBeacon: true,
      content: t('displaysTheCommissionAmount'),
    },
    {
      target: '#order-commission-plan',
      disableBeacon: true,
      content: t('thisDropdownAllowsYouToChange'),
    },
    {
      target: '#order-assigned-employee',
      disableBeacon: true,
      content: t('assignAnEmployeeToEachOrder'),
    },
  ];

  return (
    <TourGuide steps={tourSteps} run={runTour} onFinish={handleFinishTour} />
  );
};

export {
  OrdersTour,
};
